import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import validate from '../../../../validations';
import { NAME_MAX_LENGTH } from 'data/global';

export default function useValidations() {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      name: validate.composeValidators(
        validate.required(),
        validate.noLongerThan(
          NAME_MAX_LENGTH,
          t('noLongerThan', { length: NAME_MAX_LENGTH }),
        ),
        validate.fullNameValidation(t('specialCharactersOrNumbersNotAllowed')),
      ),
      lastName: validate.composeValidators(
        validate.noLongerThan(
          NAME_MAX_LENGTH,
          t('noLongerThan', { length: NAME_MAX_LENGTH }),
        ),
        validate.fullNameValidation(t('specialCharactersOrNumbersNotAllowed')),
      ),
      password: validate.composeValidators(
        validate.required(
          t('requiredField2', {
            fieldName: t('password').toLowerCase(),
          }),
        ),
        validate.passwordFieldsValidation(),
      ),
    }),
    [t],
  );
}
